import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { UpdateQuoteApiResultModel } from "@WhiteCap/Store/Service/OsnQuotes/OsnQuotesApiModels";
import { updateQuoteService } from "@WhiteCap/Store/Service/OsnQuotes/OsnQuotesServices";

export interface UpdateQuoteApiParameter extends ApiParameter {
    quoteNumber: string;
    createdBy: string;
    branchContactId: string;
    shipToId: string;
    billToId: string;
    warehouseId: string;
    shippingMethodCode: string;
    quoteName: string;
    quoteRequestedDate: string;
    poNumber: string;
    quoteExpiryDate: string;
    salesRepEmail: string;
    billToFirstName: string;
    billToLastName: string;
    shipToFirstName: string;
    shipToLastName: string;
    subtotal: number;
    quoteLineCollection: QuoteLineCollectionApiParameter[];
    onError?: (error: string) => void;
    onSuccess?: () => void;
    isSuccess?: boolean;
}

export interface QuoteLineCollectionApiParameter {
    productId: string;
    productNumber: string;
    qty: number;
    quotePrice: number;
    listPrice: number;
    isEbsQuoteLine: boolean;
    lineNumber: number,
}
type HandlerType = CustomApiHandler<UpdateQuoteApiParameter, UpdateQuoteApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/UpdateQuote/BeginUpdatingQuote",
    });
};

export const MakeApiRequest: HandlerType = async props => {
    const result = await updateQuoteService(
        props.apiParameter.quoteNumber,
        props.apiParameter.createdBy,
        props.apiParameter.branchContactId,
        props.apiParameter.billToId,
        props.apiParameter.shipToId,
        props.apiParameter.warehouseId,
        props.apiParameter.shippingMethodCode,
        props.apiParameter.quoteName,
        props.apiParameter.quoteRequestedDate,
        props.apiParameter.poNumber,
        props.apiParameter.quoteExpiryDate,
        props.apiParameter.salesRepEmail,
        props.apiParameter.billToFirstName,
        props.apiParameter.billToLastName,
        props.apiParameter.shipToFirstName,
        props.apiParameter.shipToLastName,
        props.apiParameter.subtotal,
        props.apiParameter.quoteLineCollection,
    );
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter?.onSuccess) {
            props.apiParameter.onSuccess();
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/UpdateQuote/UpdateQuoteError",
        });
        return false;
    }
};

export const DispatchCompleteApplyPodSubscriptions: HandlerType = props => {
    props.dispatch({
        type: "Custom/UpdateQuote/CompleteUpdatingQuote",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, MakeApiRequest, DispatchCompleteApplyPodSubscriptions];

const osnUpdateQuote = createHandlerChainRunner(chain, "OsnUpdateQuote");
export default osnUpdateQuote;
